export default {
  id: 'Dashboard',
  code: 'CN',
  text: {
    'Dashboard': '仪表盘',
    "Today's Lessons": '当日课程',
    "Recent Activity Log": '最近的操作记录',
    "More": "查看更多",
    'Registered Students': '在读学生',
    'Registered Teachers': '在职老师',
    'Classes': '班级',
    'Private Classes': '私课',
    'Contacts': '联系人',
    'Date': '日期',
    'Percentage':'百分比',
    'Past {numberOfDays} days' : '过去{numberOfDays}天',
    'Quantity': '数量',
    'Attending Rate': '出勤率',
    'Absent Rate': '缺勤率',
    'From Poster': '海报报名',
    'From Reception': '直接添加',
    'From Contact': '联系人转换',
    'No Lesson Data': '暂无课程数据',
    'No New Registration': '暂无新注册学生',
    'No Activity Log': '暂无操作记录',
    'No Checkin Data': '暂无签到数据',
    'Attending and Absent Rate for All Classes': '所有班级出勤率与缺勤率',
    'New Student Registration Data': '新学生注册数据',
    'No Permission': '无权限',
    'Please upgrade to higher subscription plan to unlock this feature': '请升级您的计划以解锁此功能',
    'Lesson': '课节'
  }
}
  


// WEBPACK FOOTER //
// ./src/containers/pages/Dashboard/locale.js